import timezone from './timezone';
import { ICommonStateCountry, ICommonStateObject } from '../interfaces/IForum';
import { EventOrgCategory, IOrganizerOther } from './eventDetail';
import { IUserPhotoData } from 'redhotpie-shared-lib/interfaces/IUser';
import { IMainPhoto } from '../interfaces/IUser';
import { utils } from 'views/User/UserValidationsView/UserValidationsHelper';

export default class eventSearch {
  searchItem: any;
  organiser: IOrganizerOther;

  constructor() {
    this.searchItem = {
      interestCountGuest: 0,
      interestCountUpgrade: 0,
      interestCount: 0,
      hasExpressInterest: false,
      eventId: 0,
      title: '',
      dateHeld: '',
      categories: [],
      organiserType: '',
      eventBannerUrl: '',
      eventFeaturedBannerUrl: '',
      eventGlobalBannerUrl: '',
      location: {},
      guestType: {},
      ageMax: 0,
      ageMin: 0,
      dateHeldUtcIso: '',
      timezone: null,
      isViewerOwner: false,
      isUserMatching: false,
    };
    this.organiser = {
      __type: '',
      displayEmail: '',
      website: '',
      description: '',
      clubId: 0,
      clubName: '',
      location: undefined,
      categories: [],
      rating: 0,
      mainPhoto: undefined,
      isFeatured: false,
      isSponsored: false,
      userId: 0,
      isViewable: false,
    };
  }

  static mappingObjectCategory(user: any): EventOrgCategory {
    const obj = {
      value: null,
      text: '',
      isMatch: false,
    };
    obj.value = user.Value ? user.Value : null;
    obj.text = user.Text ? user.Text : null;
    obj.isMatch = user.IsMatch ? user.IsMatch : false;
    return obj;
  }

  static mappingObjectMainPhoto(user: any): IMainPhoto {
    const obj = {
      photoId: null,
      thumbUrl: '',
      fullUrl: '',
      width: null,
      height: null,
      isMain: false,
    };
    obj.photoId = user && user.PhotoID ? user.PhotoID : 0;
    obj.thumbUrl = user && user.ThumbUrl ? user.ThumbUrl : null;
    obj.fullUrl = user && user.FullUrl ? user.FullUrl : null;
    obj.width = user && user.Width ? user.Width : null;
    obj.height = user && user.Height ? user.Height : null;
    obj.isMain = user && user.IsMain ? user.IsMain : false;
    return obj;
  }

  static mappingObjectLocation(object: any): ICommonStateObject {
    const newObject = {
      city: '',
      state: '',
      stateAbbr: '',
      country: '',
    };
    newObject.city = object && object.City ? object.City : '';
    newObject.state = object && object.State ? object.State : '';
    newObject.stateAbbr = object && object.StateAbbr ? object.StateAbbr : '';
    newObject.country = object && object.Country ? object.Country : '';
    return newObject;
  }

  static mappingObject(user: any): eventSearch {
    const { SearchItem, Organiser } = user;
    const event = new eventSearch();
    let clubId = -1;
    if (SearchItem.OrganiserType === 'Club' && Organiser.ClubID) {
      clubId = Organiser.ClubID;
    } else if (SearchItem.OrganiserType !== 'Club' && Organiser.MemberID) {
      clubId = Organiser.MemberID;
    }
    let clubName = null;
    if (SearchItem.OrganiserType === 'Club' && Organiser.ClubName) {
      clubName = Organiser.ClubName;
    } else if (SearchItem.OrganiserType !== 'Club' && Organiser.UserName) {
      clubName = Organiser.UserName;
    }

    event.searchItem = {
      interestCountGuest: SearchItem.InterestCountGuest ? SearchItem.InterestCountGuest : 0,
      interestCountUpgrade: SearchItem.InterestCountUpgrade ? SearchItem.InterestCountUpgrade : 0,
      interestCount: SearchItem.InterestCount ? SearchItem.InterestCount : 0,
      hasExpressInterest: SearchItem.HasExpressInterest ? SearchItem.HasExpressInterest : false,
      eventId: SearchItem.EventID ? SearchItem.EventID : 0,
      title: SearchItem.Title ? SearchItem.Title : '',
      dateHeld: SearchItem.DateHeld ? SearchItem.DateHeld : '',
      dateHeldDisplay: SearchItem.DateHeldDisplay ? SearchItem.DateHeldDisplay : '',
      categories:
        SearchItem.Categories && SearchItem.Categories.length > 0
          ? SearchItem.Categories.map((item: any) => eventSearch.mappingObjectCategory(item))
          : [],
      organiserType: SearchItem.OrganiserType ? SearchItem.OrganiserType : '',
      eventBannerUrl: SearchItem.EventBannerUrl ? SearchItem.EventBannerUrl : '',
      eventFeaturedBannerUrl: SearchItem.EventFeaturedBannerUrl ? SearchItem.EventFeaturedBannerUrl : '',
      eventGlobalBannerUrl: SearchItem.EventGlobalBannerUrl ? SearchItem.EventGlobalBannerUrl : '',
      location: SearchItem.Location ? eventSearch.mappingObjectLocation(SearchItem.Location) : null,
      guestType: SearchItem.GuestTypes ? SearchItem.GuestTypes.map((item: any) => eventSearch.mappingObjectCategory(item)) : [],
      ageMax: SearchItem.AgeRange ? SearchItem.AgeRange.AgeTo : 0,
      ageMin: SearchItem.AgeRange ? SearchItem.AgeRange.AgeFrom : 0,
      dateHeldUtcIso: SearchItem.DateHeldUtcIso ? SearchItem.DateHeldUtcIso : '',
      isFeatured: SearchItem.IsFeatured || false,
      isSponsored: SearchItem.IsSponsored || false,
      timezone: SearchItem.TimeZone ? timezone.mappingObject(SearchItem.TimeZone) : null,
      isViewerOwner: SearchItem.IsViewerOwner || false,
      isUserMatching: SearchItem.IsUserMatching || false,
    };
    event.organiser = {
      __type: Organiser.__type ? Organiser.__type : '',
      displayEmail: Organiser.DisplayEmail ? Organiser.DisplayEmail : '',
      website: Organiser.Website ? Organiser.Website : '',
      description: Organiser.Description ? Organiser.Description : '',
      clubId,
      clubName,
      location: Organiser.Location ? eventSearch.mappingObjectLocation(Organiser.Location) : undefined,
      categories:
        Organiser.Categories && Organiser.Categories.length > 0
          ? Organiser.Categories.map((item: any) => eventSearch.mappingObjectCategory(item))
          : [],
      rating: Organiser.Rating ? Organiser.Rating : null,
      userId: Organiser.MemberID ? Organiser.MemberID : 0,
      isViewable: !!Organiser.IsViewable,
      mainPhoto: Organiser.MainPhoto ? eventSearch.mappingObjectMainPhoto(Organiser.MainPhoto) : undefined,
    };
    return event;
  }

  static mappingObjectsCustomEventSearch(_users: any[]) {
    return (_users || []).map((_user: any) => eventSearch.mappingObject(_user.eventSearch || _user));
  }
}
